import { useTranslation } from 'react-i18next';
import { FiMail } from 'react-icons/fi';
import { z } from 'zod/v3';

import { TextInput } from '@highlight-cp/core-ui';
import type { TextInputProps } from '@highlight-cp/core-ui';

const EmailInput = ({ ...rest }: TextInputProps) => {
  const { t } = useTranslation();

  return (
    <TextInput
      aria-label={t('Email address')}
      label={t('Email address')}
      placeholder={t('Enter your email address')}
      leftSection={<FiMail />}
      {...rest}
    />
  );
};

/**
 * A zod validator for an email address.
 * @usage
 * ```ts
 * const form = useForm({
 *   validate: schemaResolver(
 *     z.object({
 *       email: EmailInput.zodValidator,
 *     }),
 *     { sync: true },
 *   ),
 * });
 * ```
 */
EmailInput.zodValidator = z.string().min(1, 'Email is required').email('Invalid email address');

export default EmailInput;
